import styled from "styled-components";
import {colors, sizes} from "../../../../themes";

export const Wrapper = styled.div`
  width: 1080px;
  box-sizing: border-box;
  background: ${colors.background.white};
  border: 1px solid ${colors.border.poloBlue};
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  position: relative;
  @media only screen and ${sizes.max991} {
    width: 100%;
  } 
`;

export const CloseIcon = styled.img`
  width: 24px;
  cursor: pointer;
  position: absolute;
  top: 14px;
  right: 11px;
`;

export const IconWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-top: 43px;
  padding-bottom: 0;
  background: ${colors.background.cinderella};
  border-radius: 8px 8px 0 0;
  @media only screen and ${sizes.max991} {
    img {
      width: 27.8vw;
    }
  }
`;

export const DialogContent = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;
  @media only screen and ${sizes.max991} {
    padding-left: 4vw;
    padding-right: 4vw;
  }
`;

export const DialogText = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items:center;
  justify-content: center;
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 140%;
  color: ${colors.text.mineShaft};
  .bold {
    font-weight: 700;
    margin-bottom: 5px;
  }
  @media only screen and ${sizes.max991} {
    font-size: 3vw;
  }
`;

export const DialogTitle = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 27px;
  line-height: 120%;
  display: flex;
  align-items: center;
  text-align: center;
  color: ${colors.text.burntSienna};
  padding-top: 41px;
  padding-bottom: 24px;
  @media only screen and ${sizes.max991} {
    font-size: 5vw;
    padding-top: 5vw;
    padding-bottom: 3vw;
  }
`;

export const RecheckButton = styled.div`
  background: ${colors.background.white};
  border: 1px solid ${colors.border.poloBlue};
  border-radius: 4px;
  padding: 11px 38px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
  color: #0036B1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  align-self: center;
  :hover {
    background-color: ${colors.background.lilyWhite};
  }
  margin-top: 112px;
  margin-bottom: 50px;
  @media only screen and ${sizes.max991} {
    font-size: 3.5vw;
    margin-top: 14vw;
    margin-bottom: 10vw;
    padding: 2.5vw 6vw;
  }
`;
